import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { CertPdfChkDetail, PatentRightsDetail } from 'src/types/api/patentRightsApiTypes';
import { PrimaryColors } from 'src/types/globalTypes';
import { stringToDate } from 'src/utils/formatters';
import { addDate } from 'src/utils/indexs';
import { ButtonA } from '../../DetailPage';
import { FaFilePdf } from 'react-icons/fa';
import { mobilePoint } from 'src/styles/globalStyle';

const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  color: ${colors.BlueGray_400};
  align-items: center;

  @media (max-width: ${mobilePoint}) {
    display: block;
  }
`;

const enum PdfStatus {
  D = '',
  Y = '※智慧財產權ｅ網通列印資料，僅供參考',
  P = '※專利證書影像檔自公告日後第15日始予提供',
  N = '※專利證書影像檔暫未提供',
  S = '※因發明人（新型創作人/設計人）放棄姓名表示權，專利證書影像檔不提供預覽及下載',
  O = `※專利證書影像檔自公告日期2017-09-01起提供`,
}

interface Iprops {
  data: PatentRightsDetail;
  certPdfChkDetail: CertPdfChkDetail;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * QRcode 區塊。
 */
const PdfDownloadPatent: React.FC<Iprops> = ({ data, certPdfChkDetail, colorType, noContent }) => {
  /** 指定日期，自該日期後案件提供PDF檔 */
  const PATENT_SDATE = new Date('2017-09-01');

  const getStatus = () => {
    let pdfStatus = PdfStatus.D;
    if (!data.patentRight.cancelResult && !data.patentRight.revokeResult) {
      const publishDate = stringToDate(data.publicationReference.publishDate);

      if (certPdfChkDetail.pdfUrl) {
        // 如有檔案，公告日期+15日後才開放預覽及下載
        const openDate = publishDate && addDate(publishDate, 15);
        if (openDate && new Date().getTime() >= openDate.getTime()) {
          pdfStatus = PdfStatus.Y;
        } else {
          pdfStatus = PdfStatus.P;
        }
      } else {
        // 如無檔案，判斷公告日期是否晚於指定時間
        if (publishDate && publishDate.getTime() <= PATENT_SDATE.getTime()) {
          pdfStatus = PdfStatus.O;
        } else {
          pdfStatus = PdfStatus.N;
        }
      }
      // 若案件有任一發明人/新型創作人/設計人放棄姓名表示權，則該筆證書影像檔即不提供預覽及下載
      for (const inventor of data.inventors) {
        const name = inventor.chineseName;
        if (name.indexOf('姓名') >= 0) {
          pdfStatus = PdfStatus.S;
          break;
        }
      }
    }
    return pdfStatus;
  };
  const status = getStatus();

  return status === PdfStatus.Y ? (
    <Wrapper>
      <ButtonA
        color={colorType.forth}
        href={process.env.REACT_APP_API_URL + certPdfChkDetail.pdfUrl}
      >
        <FaFilePdf color={colorType.seventh} />
        PDF
      </ButtonA>
      <div>{status}</div>
    </Wrapper>
  ) : (
    <Wrapper>
      {noContent}
      <div>{status}</div>
    </Wrapper>
  );
};

export default PdfDownloadPatent;
